import get from 'lodash/get';

const stageEnvironment = { auth: '8Nz6wHaZIgwmlnLZ_CN6Mg', preview: 'env-43' };
const devEnvironment = { auth: 'sdotOmBYj7gJg9o9C37Svw', preview: 'env-44' };

const envMap = {
  stage: stageEnvironment,
  dev: devEnvironment,
  local: devEnvironment
};

/**
 * Returns the search parameters for the provided application environment
 *
 * @param {string} appEnvironment
 * @returns {string}
 */
const getQueryString = (appEnvironment) => {
  // These search parameters are only necessary for non-production environments
  if (appEnvironment === 'prod') {
    return '';
  }

  const { auth, preview } = get(envMap, appEnvironment, devEnvironment);

  return `&gtm_auth=${auth}&gtm_preview=${preview}&gtm_cookies_win=x`;
}

export default {
  /**
   * Adds GTM Tracking code
   *
   * @param {Vue} vue
   * @param {Object} options
   * @param {string} options.appEnvironment - process.env.APP_ENV
   * @param {string} options.gtmId - process.env.GTM_ID
   * @param {Object} options.window
   *
   * @returns {void}
   */
  install (vue, options) {
    const gtmId = options.gtmId;
    const qs = getQueryString(options.appEnvironment);
    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl+qs;f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer', gtmId);
  }
}
